
export default {
  head() {
    return {
      link: [],
    };
  },
};
